import { ArrowUpFill } from "./arrowUp";

export function ArrowDownFill(props) {
  return <ArrowUpFill className="transform rotate-180" {...props} />;
}
